import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

const Profile = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      try {
        const parsed = JSON.parse(storedUser);
        setUser(parsed);
      } catch (err) {
        console.error("Error al leer el usuario:", err);
      }
    } else {
      
      navigate("/login");
    }
  }, [navigate]);

  if (!user) return <p style={{ marginTop: "70px", textAlign: "center" }}>Cargando perfil...</p>;

  return (
    <div style={{ marginTop: "70px", textAlign: "center" }}>
      <h2>Perfil del Usuario</h2>
      <p><strong>Nombre:</strong> {user.name}</p>
      <p><strong>Apellido:</strong> {user.last_name}</p>
      <p><strong>Email:</strong> {user.email}</p>
      <button onClick={() => navigate("/")}>Volver al Inicio</button>
    </div>
  );
};

export default Profile;
